import { Info, Barcode, Clock, MapPin, Droplet, Fuel } from "lucide-react";

const AEFuelData = ({aeFuelConsData, fuelId}) => {
  const sulfurContentRaw = aeFuelConsData.latestRecord.sulfurContent ?? "";
  const sulfurContent = sulfurContentRaw.toString().trim();

  const formattedSulfurContent =
    !sulfurContent || sulfurContent.toUpperCase() === "N/A"
      ? "N/A"
      : sulfurContent.endsWith("%")
        ? sulfurContent.replace("%", " %")
        : `${sulfurContent} %`;

  console.log("formattedSulfurContent:", formattedSulfurContent);

  const normalizeFuelType = (fuelType) => {
    try {
      if (!fuelType) return "N/A";
      
      if (Array.isArray(fuelType)) {
        const validFuels = fuelType
          .map(fuel => {
            if (fuel == null) return '';
            if (typeof fuel === 'string') return fuel.trim();
            return String(fuel).trim();
          })
          .filter(fuel => fuel && fuel !== "N/A" && fuel !== "null" && fuel !== "undefined");
        
        const uniqueFuels = [...new Set(validFuels)];
        return uniqueFuels.length > 0 ? uniqueFuels.join(", ") : "N/A";
      }
      
      if (typeof fuelType === 'string') {
        const trimmed = fuelType.trim();
        return trimmed && trimmed !== "N/A" ? trimmed : "N/A";
      }
      
      return String(fuelType || "N/A");
    } catch (error) {
      console.warn('Error normalizing fuel type:', error);
      return "N/A";
    }
  };

  const fuelData = [
    {
      label: "Fuel ID",
      value: fuelId,
      icon: <Barcode className="w-4 h-4" />,
      color: "bg-[#1a52761a] text-[#1a5276]"
    },
    {
      label: "Sulfur content",
      value: formattedSulfurContent,
      icon: <Droplet className="w-4 h-4" />,
      color: "bg-[#d354001a] text-[#d35400]"
    },
    {
      label: "Fuel type",
      value: normalizeFuelType(aeFuelConsData?.allFuelTypes?.aeFuelTypes),
      icon: <Fuel className="w-4 h-4" />,
      color: "bg-[#27ae601a] text-[#27ae60]"
    }
  ];

  return (
    <div className="bg-white w-[40%] rounded-xl border border-gray-100 shadow-sm overflow-hidden flex flex-col">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
            <Droplet className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800 tracking-tight">
            AE Fuel
          </h2>
        </div>
      </div>
      
      {/* Data Grid */}
      <div className="flex flex-col gap-1 p-5 flex-1 justify-around">
        {fuelData.map((item, index) => (
          <div 
            key={index} 
            className="flex items-start gap-4 p-3 hover:bg-gray-50/50 rounded-lg transition-colors duration-150"
          >
            {/* Boxed Icon */}
            <div className={`p-2.5 rounded-lg ${item.color} flex-shrink-0`}>
              {item.icon}
            </div>
            
            {/* Text Content */}
            <div className="flex flex-col gap-0.5">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                {item.label}
              </span>
              <span className="text-sm font-semibold text-gray-800">
                {item.value}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AEFuelData;